import { useEffect } from 'react';

const DEFAULT_IMAGE = 'https://pushateez.com/og-production.jpg';

function setTag(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setMeta(name, content, attr = 'name') {
  setTag(`meta[${attr}="${name}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute(attr, name);
    return m;
  }, 'content', content);
}

function setCanonical(href) {
  setTag('link[rel="canonical"]', () => {
    const l = document.createElement('link');
    l.setAttribute('rel', 'canonical');
    return l;
  }, 'href', href);
}

// Sets per-route title, description, canonical, robots, Open Graph and Twitter tags.
// noindex: starter pages (noindex, follow). isPrivate: admin pages (noindex, nofollow, no canonical).
export default function useSeo({ title, description, path, image, type = 'website', keywords, noindex = false, isPrivate = false, canonical = true }) {
  useEffect(() => {
    if (!title) return;
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    const img = image ? new URL(image, window.location.origin).href : DEFAULT_IMAGE;
    document.title = title;
    setMeta('robots', isPrivate ? 'noindex, nofollow' : noindex ? 'noindex, follow' : 'index, follow');
    if (!keywords) document.head.querySelector('meta[name="keywords"]')?.remove();
    if (isPrivate || !canonical) {
      document.head.querySelector('link[rel="canonical"]')?.remove();
      if (isPrivate) return;
    } else {
      setCanonical(url);
    }
    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:url', url, 'property');
    setMeta('og:type', type, 'property');
    setMeta('og:image', img, 'property');
    setMeta('og:image:secure_url', img, 'property');
    setMeta('og:image:alt', title, 'property');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', img);
    setMeta('twitter:image:alt', title);
  }, [title, description, path, image, type, keywords, noindex, isPrivate, canonical]);
}
